<template>
	<div class="fixed inset-0 flex items-center justify-center bg-trans-gray z-20" v-show="show">
		<div class="rounded shadow bg-white w-full mx-1 sm:w-2/3">
			<div class="rounded-t bg-gray-800 px-4 py-4 text-white font-thin text-lg">
				Change Supplier for {{ orderNumber }}
			</div>
			<div class="p-4 space-y-1">
				<div class="flex items-center justify-between">
					<div class="flex-1">&nbsp;</div>
					<div class="flex items-center space-x-1">
						<div class="w-20 text-left">ordered</div>
						<div class="w-20 text-left">change</div>
						<div class="w-40">new supplier</div>
						<div class="w-20">new price</div>
					</div>
				</div>
				<div class="flex items-center justify-between" v-for="(product, index) in existingOrder" v-if=" product.ordered_qty - product.received_qty">
					<div class="">{{ product.name }} <span class="text-white text-xs">{{ product.id }}</span></div>
					<div class="flex items-center space-x-1">
						<div class="w-20">{{ (product.ordered_qty - product.received_qty) - (existingOrder[index]['change_qty']) }}</div>
						<div class="w-20">
							<input class="w-20" type="text" v-model="existingOrder[index]['change_qty']" name="change" @input="checkAmount(index)" />
						</div>
						<div class="w-40">
							<select :disabled="! existingOrder[index]['change_qty']" v-model="existingOrder[index]['supplier']" name="supplier" class="form-select w-40" @change="setPrice(product.id, index, $event)">
								<template v-for="(supplier, index) in suppliers">
									<option :value="supplier.id" :key="supplier.id">{{ supplier.name }}</option>
								</template>
							</select>
						</div>
						<div class="w-20">
							<input :disabled="! existingOrder[index]['change_qty']" class="w-20" v-model="existingOrder[index]['price_in_rands']" type="text" @input="updatePrice(index, $event)" name="price" />
						</div>
					</div>
				</div>
			</div>
			<div class="rounded-b bg-gray-200 px-4 py-2">
					<div class="flex items-center justify-between">
						<action-button class="link mr-6" @button-clicked="cancel">Cancel</action-button>
						<action-button class="btn btn-blue" @button-clicked="save">Save</action-button>
					</div>
				</div>
		</div>
	</div>
</template>

<script>

export default {
	props: ['show', 'orderNumber', 'order'],
	data () {
		return {
			priceError: [],
			update: {},
			suppliers: [],
			existingOrder: this.$_.cloneDeep(this.order),
		}
	},
	filters:{
		toNumber: function(value){
			let val = value/100;
			return val === 0 ? null : val;
		}
	},
	methods: {
		cancel: function(){
			this.$emit('close');
		},
		updatePrice: function(index, event){
			this.existingOrder[index]['price_in_rands'] = event.target.value;
			this.existingOrder[index]['price'] = event.target.value *100;
		},
		save: function(){
			let order = this.existingOrder.filter(i => i.change_qty > 0);
			this.$emit('save', order, this.orderNumber);
		},
		setPrice(product_id, index, event){
			let supplier_id = event.target.value;
			this.$set(this.existingOrder[index],'price','');
			this.$http.get('/price/'+product_id)
			.then(response => {
				console.log(response.data);
				let supplierPrice = response.data.suppliers.filter(supplier => supplier.id == supplier_id);
				let val = supplierPrice[0] ? supplierPrice[0]['price'] : null;
				this.$nextTick(function () {
					this.existingOrder[index]['price_in_rands'] = val / 100;
					this.existingOrder[index]['price'] = val;				
				});
			})
			.catch(error => {
				console.log(error);
				let err = {
					title: 'Server responded with a ' + error.response.status,
					message: error.response.data.message,
					type: 'error'
				}
				// this.$store.commit('setStatus', err)
			}).then(()=>{
				this.loading = false
			})
		},
		checkAmount(index){
			if((this.existingOrder[index]['ordered_qty'] - this.existingOrder[index]['received_qty']) - this.existingOrder[index]['change_qty'] < 0){
				this.$set(this.existingOrder[index], 'change_qty', this.existingOrder[index]['ordered_qty'] - this.existingOrder[index]['received_qty']);
			}
		}
	},
	computed: {
		
	},
	components: {
		
	},
	watch: {
		show: {
			immediate: true,
			handler: show => {
				if (show) {
					document.body.style.setProperty('overflow', 'hidden')
				} else {
					document.body.style.removeProperty('overflow')
				}
			}
		}
	},
	created () {
		this.existingOrder.forEach((e, i) => {
			this.$set(this.existingOrder[i],'original_ordered_qty',e.ordered_qty);
			this.$set(this.existingOrder[i],'change_qty',null);
			this.$set(this.existingOrder[i],'price',null);
			this.$set(this.existingOrder[i],'price_in_rands',null);
		});
		this.$http.get('/suppliers/')
			.then(response => {
				this.suppliers = response.data
				
			})
			.catch(error => {
				console.log(error);
				let err = {
					title: 'Server responded with a ' + error.response.status,
					message: error.response.data.message,
					type: 'error'
				}
				// this.$store.commit('setStatus', err)
			}).then(()=>{
				this.loading = false
			})
		const listener = document.addEventListener('keydown', e => {
			if (this.show && e.keyCode === 27) {
				this.cancel()
			}
		})

		this.$once('hook:beforeDestroy', () => {
			//document.removeEventListener('keydown', listener)
			document.body.style.removeProperty('overflow')
		});
	}
}
</script>
